import { inspire } from "../../abilities/paladin/inspire";
const BARD_HATS = [
  {
    slug: "bard-black-22",
    name: "Bard",
    description: "Sing your way to victory",
    rarity: "epic",
    slot: "hat",
    statChanges: [
      {
        stat: "blackColor",
        value: 35
      },
      {
        stat: "blackRes",
        value: 15
      },
      {
        stat: "redColor",
        value: 10
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_black",
      frameIndex: 22
    },
    tags: ["daily-rotation"],
    grantedActions: { inspire },
    shopCategory: "hat"
  },
  {
    slug: "bard-blue-22",
    name: "Bard",
    description: "Sing your way to victory",
    rarity: "epic",
    slot: "hat",
    statChanges: [
      {
        stat: "blueColor",
        value: 35
      },
      {
        stat: "blueRes",
        value: 15
      },
      {
        stat: "goldColor",
        value: 10
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_blue",
      frameIndex: 22
    },
    tags: ["daily-rotation"],
    grantedActions: { inspire },
    shopCategory: "hat"
  },
  {
    slug: "bard-green-22",
    name: "Bard",
    description: "Sing your way to victory",
    rarity: "epic",
    slot: "hat",
    statChanges: [
      {
        stat: "greenColor",
        value: 35
      },
      {
        stat: "greenRes",
        value: 15
      },
      {
        stat: "blueColor",
        value: 10
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_green",
      frameIndex: 22
    },
    tags: ["daily-rotation"],
    grantedActions: { inspire },
    shopCategory: "hat"
  },
  {
    slug: "bard-orange-22",
    name: "Bard",
    description: "Now THIS will get some attention",
    rarity: "legendary",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 50
      },
      {
        stat: "greenRes",
        value: 25
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_orange",
      frameIndex: 22
    },
    tags: ["daily-rotation"],
    grantedActions: { inspire },
    shopCategory: "hat"
  },
  {
    slug: "bard-pink-22",
    name: "Bard",
    description: "Awarded to the first few users of Choreboard!",
    rarity: "epic",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 35
      },
      {
        stat: "goldColor",
        value: 35
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_pink",
      frameIndex: 22
    },
    tags: ["beta-exclusive"],
    grantedActions: { inspire },
    shopCategory: "hat"
  }
];
export {
  BARD_HATS
};
//# sourceMappingURL=data:application/json;base64,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
